<template>
  <Upload v-bind="$attrs" v-on="$listeners" />
</template>

<script>
  export default {
    name: 'BUpload',
    props: {
    }
  }
</script>

<style scoped>

</style>
